<template>
	<div class='main-mybody' id='quanx_weitijao'>
		<a-row style='overflow-x: hidden;overflow-y: auto; height: 21rem;'>
			<a-col :span='12'>
				<a-row v-for='(item,ind) in columnsData.leftresult' :key='ind+"1001"'>
					<div class='look_g' v-if='item.pics'>
						<img :src="item.pics" alt="" style="width: 0.8rem;position: relative;
    top: -0.1rem;">
						{{item.secondclassname}}
					</div>
					<div class='look_g' v-else>
						<div></div>{{item.secondclassname}}
					</div>
					<a-row>
							<a-col :span='4' v-if='item.secondList.length == 0'>
								<span class='grayman'>暫無權限</span>
							</a-col>
							<!-- parseInt(24/(item.rowsize||4)) -->
							<a-col :span='8' v-else v-for='(val,i) in item.secondList' :key='i+"1003"'>
								<div class='warp_gre'>
									 <!-- value="uncheck" name="check" onclick="this.value=(this.value=='uncheck')?'checked':'uncheck'"> -->
									 <!-- @change="onChange(items.details)" default-value='1' -->
									<a-checkbox v-model='val.selected' value="1">
										<span class='grayman'>{{val.detail}}</span>
									</a-checkbox>
								</div>
							</a-col>
					</a-row>
					<div class='main-wid main-wids' v-if='ind+1<columnsData.leftresult.length'></div>
					<br v-if='ind+1<columnsData.leftresult.length'>
				</a-row>
			</a-col>
			<a-col :span='12'>
				<a-row v-for='(item,ind) in columnsData.rightresult' :key='ind+"2020"'>
					<div class='look_g' v-if='item.pics'>
						<img :src="item.pics" alt="" style="width: 0.8rem;position: relative;top: -0.1rem;">
						{{item.secondclassname}}
					</div>
					<div class='look_g' v-else>
						<div></div>{{item.secondclassname}}
					</div>
					
						<a-row>
						<a-col :span='4' v-if='item.secondList.length == 0'>
							<span class='grayman'>暫無權限</span>
						</a-col>
						<!-- parseInt(24/(item.rowsize||3)) -->
						<a-col :span='8' v-else v-for='(val,i) in item.secondList' :key='i+"2022"'>
							<!-- :default-value='1' -->
							<a-checkbox v-model='val.selected' @change="onChange" value="1">
								<span class='grayman'>{{val.detail}}</span>
							</a-checkbox>
						</a-col>
					</a-row>
					<div class='main-wid main-wids' v-if='ind+1<columnsData.rightresult.length'></div>
					<br v-if='ind+1<columnsData.rightresult.length'>
				</a-row>
			</a-col>
		</a-row>
		<br>
		<div class='warp_daochu'>
			<div style="padding-left: .5rem;"></div>
			<div>
				<button class='btn1 btnx' @click='resetForm("1")'>保 存</button>
				<!-- <button class='btn1 btn2' @click='resetForm("2")'>提交</button> -->
			</div>
		</div>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		props: ['itemobj','islands'],
		data() {
			return {
				// v-if="$store.state.rolesdata.indexOf('khadmin1') >= 0"
				val:'',
				columnsData: {},
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					begindate: '',
					enddate: '',
					perPage: 10, //每頁條目數
					revisistatus: '',
				}
			}
		},
		computed: {},
		watch:{
			islands:{
				handler(){
					this.getdate()
				}
			}
		},
		mounted() {
			this.getdate()
		},
		methods: {
			onChange(checkedValues) {
			      console.log('checked = ', checkedValues);
			    },
			getdate() {
				this.params.token = this.$store.state.token
				this.$ajax({
					method: 'post',
					url: this.$api.getAuthorizationList,
					data: {
						"userid": this.itemobj.userid,
						"firstid":this.islands
					}
				}).then(res => {
					if (res.data.qmiscode == 1000) {
						this.columnsData = res.data
					} else {
						this.$message.warning(res.data.qmismsg)
					}
				})
			},
			resetForm(){
				console.log(this.columnsData)
				this.$ajax({
					method:'post',
					url:this.$api.newAuthor,
					data:{
						"userid": this.itemobj.userid,
						"firstid":this.islands,
						 leftresult: this.columnsData.leftresult,
						 rightresult:this.columnsData.rightresult,
					}
				}).then(res=>{
					this.$message.success('操作成功')
					this.$emit('child',1)
				}).catch(err=>{
					this.$message.waring(err.data.qmismsg)
				})
			}
		}
	}
</script>

<style lang="scss">
	#ediotable tr td:nth-last-child(1),
	#ediotable tr th:nth-last-child(1) {
		border-right: 1px solid #e8e8e8 !important;
	}

	#ediotable .ant-table-bordered .ant-table-thead>tr>th,
	#ediotable .ant-table-bordered .ant-table-tbody>tr>td {
		border-right: unset;
	}

	#quanx_weitijao .paginationView {
		padding: 0.5rem 0;
		display: flex;
		align-items: center;
		width: 100%;
		color: #666666;
		/* height:calc(100vh - 142px); */
	}

	#quanx_weitijao .warp_gre {
		// width: .5rem;
		height: .5rem;
		line-height: .5rem;
		display: inline-block;
		position: relative;
		margin-right: .2rem;
	}

	#quanx_weitijao .ant-pagination-item {
		background-color: #fff;
		border-color: #bfbfbf;
		color: #999999;
		margin-right: 1rem;
	}

	#quanx_weitijao .ant-pagination-prev {
		margin-right: 1rem;
	}

	#quanx_weitijao .ant-pagination-item a {
		color: inherit;
	}

	#quanx_weitijao .ant-pagination-item-active {
		background-color: #f3f3f3;
		border-color: #d8d8d8;
		color: #000;
	}

	#quanx_weitijao .ant-pagination-prev .ant-pagination-item-link,
	#quanx_weitijao .ant-pagination-next .ant-pagination-item-link {
		background-color: #fff;
		color: #666666;
		border: 1px solid #bfbfbf;
	}

	#quanx_weitijao .ant-pagination-disabled a,
	#quanx_weitijao .ant-pagination-disabled:hover a,
	#quanx_weitijao .ant-pagination-disabled:focus a,
	#quanx_weitijao .ant-pagination-disabled .ant-pagination-item-link,
	#quanx_weitijao .ant-pagination-disabled:hover .ant-pagination-item-link,
	#quanx_weitijao .ant-pagination-disabled:focus .ant-pagination-item-link {
		background-color: #d8d8d8 !important;
		color: #fff !important;
	}

	#quanx_weitijao .pageTzView {
		display: flex;
		align-items: center;
		margin-left: 0.7rem;
	}

	#quanx_weitijao .look_g {
		font-size: .8rem;
		margin-bottom: .5rem;
		color: #0c8b97;

		div {
			display: inline-block;
			width: 10px;
			height: .9rem;
			position: relative;
			top: .1rem;
			margin-right: .2rem;
			border-left: 5px solid #0c8b97;
		}
	}

	// #quanx_weitijao {
	// 	.grayman {
	// 		color: gray;
	// 		font-size: .75rem;
	// 	}
	// 	.main-wid {
	// 		width: 100%;
	// 		height: 1px;
	// 		border-top: .5px solid #d8d8d8;
	// 		margin: 1rem 0;
	// 	}

	// 	.main-wids {
	// 		width: 100%;
	// 	}
	// }
</style>
